import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { eThongTuActionTypeIds, IThongTuDeleteStart, IThongTuSaveStart } from "../../action-types/danh-muc/IThongTuActionTypes";
import { actions } from "../../actions/actionsWrapper";

const thongTuApi = apiWrapper.thongTu;

export function* thongTuSaga(): any {
    yield takeLatest(eThongTuActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eThongTuActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eThongTuActionTypeIds.SAVE_START, saveWorker)
}
function* loadWorker(): any {

    const res: IBaseResponeModel = yield call([thongTuApi, thongTuApi.SelectAll])
    if (res.is_success) {
        yield put(actions.danhMucWrapper.thongTu.loadSuccess(res.data))
    } else {
        yield put(actions.danhMucWrapper.thongTu.loadError(res.message || "Không tải được thông tư"))
    }
}
function* deleteWorker(action: IThongTuDeleteStart): any {
    const res: IBaseResponeModel = yield call([thongTuApi, thongTuApi.DeleteMultiple], action.payload)
    if (res.is_success) {
        yield put(actions.danhMucWrapper.thongTu.deleteSuccess())
        yield put(actions.danhMucWrapper.thongTu.loadStart())
    } else {
        yield put(actions.danhMucWrapper.thongTu.deleteError(res.message || "Không xóa được thông tư"))
    }
}
function* saveWorker(action: IThongTuSaveStart): any {
    let res: IBaseResponeModel;
    if (action.payload.id > 0) {
        res = yield call([thongTuApi, thongTuApi.Update], action.payload);
    } else {
        res = yield call([thongTuApi, thongTuApi.Insert], action.payload);
    }
    if (res.is_success) {
        yield put(actions.danhMucWrapper.thongTu.saveSuccess())
        yield put(actions.danhMucWrapper.thongTu.loadStart())
    } else {
        yield put(actions.danhMucWrapper.thongTu.saveError(res.message || "Không lưu được thông tư"))
    }
}